<template>
	<div>
		<div>
			<v-row>
				<v-col cols="12" md="3">
					<ProjectSidebar 
						:projects="Proyectic" 
						:filters="filters" 
						:selectedFilter="selectedFilter"
						:selectedProject="proyect"
						@filter-changed="filterProjects"
						@project-selected="enviarProyecto"
						@openResultDialog="opendialogResult"
						@openActiveProcessDialog="opendialogTaskProceso"
					/>
				</v-col>
				<v-col cols="12" md="9">
					<s-crud v-if="dialogTable" :title="proyect.TkpTitle" :config="config" :filter="filter"
						:add="TkpStatus == 3 ? false : true" :edit="(TkpStatus == 3 || (isSelectedTaskFinalized && !allowEditFinalizedTask)) ? false : true"
						:remove="(TkpStatus == 3 || isSelectedTaskFinalized) ? false : true" @save="save($event)" ref="gridtask"
						@rowSelected="rowSelected($event)" @addEvent="onAddEvent" searchInput :singleRow="false" :rowDefault="false">
						<template scope="props">
							<v-container class="pa-2">
								<!-- Alerta Tarea Finalizada -->
								<v-row v-if="props.item.TskStatus == 3 && !allowEditFinalizedTask" dense class="mb-4">
									<v-col cols="12">
										<v-alert type="warning" text outlined dense class="mb-0">
											<strong>Esta tarea está finalizada</strong> — No se puede editar.
										</v-alert>
									</v-col>
								</v-row>

								<!-- SECCIÓN 1: INFORMACIÓN PRINCIPAL -->
								<v-card outlined class="mb-4 elevation-0" style="border-radius: 8px;">
									<v-card-text class="pa-4">
										<div class="primary--text font-weight-bold subtitle-1 mb-3 d-flex align-center">
											<v-icon left color="primary">mdi-information-outline</v-icon>
											Información Principal
										</div>
										<v-row dense>
											<v-col cols="12" md="9">
												<s-text label="Título" v-model="props.item.TskTitle" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-text>
											</v-col>
											<v-col cols="12" md="3">
												<s-select-definition label="Clasificación" :def="1528" v-model="props.item.TypeClasification" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-definition>
											</v-col>

											<v-col cols="12">
												<s-textarea label="Descripción" v-model="props.item.TskDescription" rows="2" auto-grow :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-textarea>
											</v-col>

											<v-col cols="12" v-show="props.item.TypeClasification == 2">
												<v-file-input v-if="props.item.TypeClasification == 2" label="Anexo" v-model="Attach1" hide-details :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask" />
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>

								<!-- SECCIÓN 2 Y 3: DOS COLUMNAS -->
								<v-row dense>
									<!-- COLUMNA IZQUIERDA: DETALLES DEL USUARIO Y CONTEXTO -->
									<v-col cols="12" md="6" class="mb-4 d-flex">
										<v-card outlined width="100%" class="elevation-0" style="border-radius: 8px;">
											<v-card-text class="pa-4">
												<div class="primary--text font-weight-bold subtitle-1 mb-3 d-flex align-center">
													<v-icon left color="primary">mdi-account-outline</v-icon>
													Detalles del Usuario y Contexto
												</div>
												<v-row dense>
													<v-col cols="12" sm="4" class="s-col-form">
														<s-toolbar-person noCamera noEdit label="Usuario Solicitante" v-model="props.item.PrsDocumentNumberAttended" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask" @returnPerson="returnPerson($event, props.item)" />
													</v-col>
													<v-col cols="12" sm="8" class="s-col-form">
														<s-text readonly label="Persona" v-model="props.item.NtpFullNameAttended">
															<template v-slot:append-outer>
																<v-icon v-if="props.item.TskStatus != 3 || allowEditFinalizedTask" color="error" style="margin-top:4px; cursor: pointer;" @click="props.item.NtpFullNameAttended = null; props.item.NtpIDAttended = null;">mdi-close-circle-outline</v-icon>
															</template>
														</s-text>
													</v-col>

													<v-col cols="12" class="s-col-form">
														<s-select-area v-if="searchAre" label="Área Usuaria" :text="props.item.AreNameTask" v-model="props.item.AreIDTask" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask" />
													</v-col>

													<v-col cols="12" sm="6">
														<s-select-definition label="Canal de atención" :def="1708" v-model="props.item.TskAttentionChannel" clearable :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-definition>
													</v-col>
													<v-col cols="12" sm="6">
														<s-select-definition label="Sede / Ubicación" :def="1709" v-model="props.item.TskLocation" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-definition>
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>

									<!-- COLUMNA DERECHA: CLASIFICACIÓN TÉCNICA Y EQUIPOS -->
									<v-col cols="12" md="6" class="mb-4 d-flex">
										<v-card outlined width="100%" class="elevation-0" style="border-radius: 8px;">
											<v-card-text class="pa-4">
												<div class="primary--text font-weight-bold subtitle-1 mb-3 d-flex align-center">
													<v-icon left color="primary">mdi-hammer-wrench</v-icon>
													Clasificación Técnica y Equipos
												</div>
												<v-row dense>
													<v-col cols="12" sm="6" v-if="props.item.TypeClasification !== 2">
														<s-select-definition label="Tipo Registro" :def="1476" v-model="props.item.TypeTask" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-definition>
													</v-col>
													<v-col cols="12" :sm="props.item.TypeClasification !== 2 ? 6 : 12">
														<s-select-definition label="Categoría Técnica" :def="1710" v-model="props.item.TskTechnicalCategory" clearable :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-definition>
													</v-col>

													<v-col cols="12" sm="8" v-if="props.item.TypeClasification !== 2">
														<s-select-equipment-serie v-model="props.item.CgeID" :initial-item="props.item" :ntp-id="props.item.NtpIDAttended" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-equipment-serie>
													</v-col>

													<!-- <v-col cols="12" sm="6">
														<s-select-definition label="Complejidad" :def="1627" v-model="props.item.TskComplexity" clearable :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-definition>
													</v-col> -->
													<!-- <v-col cols="12" sm="4" class="d-flex align-center">
														<v-switch label="Requiere mantenimiento" v-model="requiresMaintenance" hide-details class="mt-0 pt-0" color="primary" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask" />
													</v-col> -->

													<v-col cols="12" sm="6" md="3" class="d-flex align-center">
														<v-switch label="Recurrente" v-model="props.item.TskIsRecurring" hide-details class="mt-0 pt-0" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></v-switch>
													</v-col>

													<v-col cols="12" class="mt-2" v-if="requiresMaintenance">
														<v-btn color="primary" small block @click="onGenerateMaintenance(props.item)" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask">
															<v-icon left>mdi-wrench</v-icon>
															Generar Mantenimiento
														</v-btn>
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>

								<!-- SECCIÓN 4: TRIAGE, TIEMPOS Y ASIGNACIÓN -->
								<v-card outlined class="elevation-0" style="border-radius: 8px;">
									<v-card-text class="pa-4">
										<div class="primary--text font-weight-bold subtitle-1 mb-3 d-flex align-center">
											<v-icon left color="primary">mdi-calendar-clock</v-icon>
											Planificación, Tiempos y Asignación
										</div>
										<v-row dense>
											<!-- Campos condicionales (TypeClasification !== 2) -->
											<v-col cols="12" sm="6" md="3" v-if="props.item.TypeClasification !== 2">
												<s-select-definition label="Prioridad" :def="1392" v-model="props.item.TskPriority" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-definition>
											</v-col>
											<v-col cols="12" sm="6" md="3" v-if="props.item.TypeClasification !== 2">
												<s-select-definition label="Criticidad" :def="1392" v-model="props.item.TskCriticality" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-definition>
											</v-col>
											<v-col cols="12" sm="6" md="3" v-if="props.item.TypeClasification !== 2">
												<s-date label="Fecha Solicitud" type="datetime" v-model="props.item.TskRequestDate" clearable :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-date>
											</v-col>
											<v-col cols="12" sm="6" md="3" v-if="props.item.TypeClasification !== 2 && $fun.isAdmin()">
												<s-select-assigned :projectID="proyect.TkpID" full return-object label="Asignado a" clearable v-model="filter.PrsID" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-select-assigned>
											</v-col>

											<!-- Campos siempre visibles -->
											<v-col cols="12" sm="6" md="3" v-if="$fun.hasSpecialPermission('advanced')">
												<s-text label="Tiempo Requerido" v-model="props.item.TskTimeRequired" type="time" placeholder="HH:mm:ss" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-text>
											</v-col>
											<v-col cols="12" sm="6" md="3" v-if="$fun.hasSpecialPermission('advanced')" class="d-flex align-center">
												<v-switch label="Validar Tiempo" v-model="props.item.TskValidateRequiredTime" hide-details class="mt-0 pt-0" :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></v-switch>
											</v-col>
											<v-col cols="12" sm="6" md="3" v-if="$fun.hasSpecialPermission('advanced')">
												<s-date label="Fecha de Inicio" type="datetime" v-model="props.item.TskDateBegin" clearable :disabled="props.item.TskStatus == 3 && !allowEditFinalizedTask"></s-date>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-container>
						</template>

						<template v-slot:filter>
							<v-container>
								<v-row>
									<v-col cols="12" md="3" v-if="filter.IsAdmin == 1">
										<s-select-assigned :projectID="filter.TkpID" full return-object
											label="Responsable" clearable v-model="filter.PrsID"></s-select-assigned>
									</v-col>
									<v-col cols="6" md="2">
										<s-select-definition label="Prioridad" :def="1392" v-model="filter.TskPriority"
											clearable></s-select-definition>
									</v-col>
									<v-col cols="6" md="3">
										<s-select-definition label="Estado" :def="1393" v-model="filter.TskStatus"
											clearable></s-select-definition>
									</v-col>
									<v-col cols="6" md="2">
										<s-select-definition label="Tipo Registro" :def="1476" v-model="filter.TypeTask"
											clearable></s-select-definition>
									</v-col>
									<v-col cols="6" md="2">
										<s-select-definition label="Clasificación" :def="1528"
											v-model="filter.TypeClasification" clearable></s-select-definition>
									</v-col>
								</v-row>
							</v-container>
						</template>

						<template v-slot:AsgWorkerName="{ row }">
							<v-btn v-if="$fun.isAdmin()" x-small color="primary" @click="AsgWorkerName(row)">
								<i class="fas fa-plus-circle"></i>
							</v-btn>
						</template>


						<template v-slot:options>
							<v-tooltip bottom="" v-if="selected.length > 0">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="bulkProductionTask()" small>
										<v-icon>mdi-cloud-upload-outline</v-icon>
									</v-btn>
								</template>
								<span>Pase a Producción / Finalizado ({{ selected.length }})</span>
							</v-tooltip>

							<v-tooltip bottom="" v-if="selected.length > 0">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="bulkTransferTask()" small>
										<v-icon>mdi-folder-move</v-icon>
									</v-btn>
								</template>
								<span>Transferir Seleccionados ({{ selected.length }})</span>
							</v-tooltip>

                            <v-tooltip bottom="" v-if="selected.length > 0 && filter.IsAdmin == 1">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="bulkTransferWorkerTask()" small>
										<v-icon>mdi-account-arrow-right</v-icon>
									</v-btn>
								</template>
								<span>Reasignar Usuarios ({{ selected.length }})</span>
							</v-tooltip>

							<v-tooltip bottom="">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="openDialogTask()" small>
										<i class="fas fa-file-upload"></i>
									</v-btn>
								</template>
								<span>Importar Tareas</span>
							</v-tooltip>

							<v-tooltip bottom="">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="previewTicket()" small>
										<v-icon>mdi-receipt-text-send-outline</v-icon>
									</v-btn>
								</template>
								<span>Enviar Correo</span>
							</v-tooltip>
							<!-- <v-tooltip bottom="" v-if="selected.TskStatus == 1 || selected.TskStatus == 2">
							<template v-slot:activator="{ on }">
								<v-btn text small style="margin-right:5px;" v-on="on" @click="pausedTask()"> 
									<v-icon style="font-size:18px;" v-if="selected.TskPaused == 0"> far fa-pause-circle</v-icon>
									<v-icon style="font-size:18px;" v-if="selected.TskPaused == 1"> far fa-play-circle</v-icon>
								</v-btn>
							</template>
<span v-if="selected.TskPaused == 0">Pausar</span>
<span v-if="selected.TskPaused == 1">Iniciar</span>
</v-tooltip> -->

							<!-- <v-tooltip bottom="" v-if="selected.TskStatus == 1 || selected.TskStatus == 2">
							<template v-slot:activator="{ on }">
								<v-btn text small style="margin-right:5px;" v-on="on" @click="transferTask()"> <v-icon style="font-size:18px;"> fas fa-random</v-icon></v-btn>
							</template>
							<span>Transferir</span>
						</v-tooltip> -->
						</template>

						<template v-slot:FilePathDownload="{ row }">
							<!-- {{ row.FilePathName }} -->
							<v-btn v-if="row.FilePath != null && row.TypeClasification == 2" color="success"
								class="mt-5" :disabled=false icon x-small @click='openFile(row.FilePath)'>
								<v-icon>mdi-download</v-icon> </v-btn>
						</template>

						<template v-slot:Action="{ row }">
							<v-btn v-if="row.TskStatus == 1" x-small dark color="success" elevation="1"
								class="text-none" @click="clickActionTask(row)">
								<v-icon left small>mdi-play</v-icon>
								{{ 'Iniciar' }}
							</v-btn>
							<v-btn v-if="row.TskStatus == 2 && row.TskPaused == 0" x-small dark color="red"
								elevation="2" class="text-none" @click="clickActionTask(row)">
								<v-icon left small>mdi-stop</v-icon>
								{{ 'Terminar' }}
							</v-btn>
						</template>

						<template v-slot:TskPause="{ row }">
							<v-btn v-if="row.TskStatus != 1 && row.TskStatus != 3 && row.TskStatus != 5" x-small dark depressed
								:color="row.TskPaused == 1 ? '#1DE9B6' : '#FF9100'" @click="clickPausedTask(row)">
								<v-icon>{{ row.TskPaused == 1 ? 'mdi-play-circle-outline' : 'mdi-pause-circle-outline'
								}}</v-icon>
							</v-btn>
						</template>

						<template v-slot:ConditButt="{ row }" v-if="$fun.isAdmin()">
							<v-btn x-small color="info" @click="clickConditionTask(row)">
								<v-icon>mdi-information</v-icon>
							</v-btn>
						</template>

						<template v-slot:TskStatus="{ row }">
							<v-chip x-small black :color="row.TskStatusColor" style="color: white;">
								{{ row.TskStatusName }}
							</v-chip>
						</template>

						<template v-slot:NameTypeTask="{ row }">
							<v-chip x-small black :color="row.TypeTask === 1 ? '#abd5f5' : '#fdeb65'">
								{{ row.NameTypeTask }}
							</v-chip>
						</template>

						<template v-slot:TskPriority="{ row }">
							<v-chip x-small black :color="row.TskPriorityColor">
								{{ row.TskPriorityName }}
							</v-chip>
						</template>

						<template v-slot:TskCriticalityName="{ row }">
							<v-chip x-small black :color="row.TskCriticalityColor"
								v-if="row.TskCriticalityName != null">
								{{ row.TskCriticalityName }}
							</v-chip>
						</template>

						<template v-slot:TskMultiple="{ row }">
							<v-menu :close-on-content-click="false" :nudge-width="200" offset-y
								transition="slide-x-reverse-transition">
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" icon x-small color="primary"
										aria-label="Opciones de tarea">
										<v-icon>mdi-dots-vertical</v-icon>
									</v-btn>
								</template>
								<v-card>
									<v-list dense>
										<v-list-item @click="clickActionTask(row)" aria-label="Iniciar"
											v-if="row.TskStatus == 1">
											<v-list-item-icon>
												<v-icon>mdi-play</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Iniciar</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="clickActionTask(row)" aria-label="Finalizar"
											v-if="row.TskStatus == 2 && row.TskPaused == 0">
											<v-list-item-icon>
												<v-icon>mdi-stop</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Finalizar</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="clickPausedTask(row)" aria-label=""
											v-if="row.TskStatus != 1 && row.TskStatus != 3 && row.TskStatus != 5">
											<v-list-item-icon>
												<v-icon>{{ row.TskPaused == 1 ? 'mdi-play-circle-outline' :
													'mdi-pause-circle-outline' }}</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>{{ row.TskPaused == 1 ? 'Reanudar' : 'Pausar'
												}}</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="clickProductionTask(row)" aria-label="Subir a Producción"
											v-if="row.TskStatus == 3">
											<v-list-item-icon>
												<v-icon>mdi-cloud-upload</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Subir a Producción</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="clickProductionTask(row)" aria-label="Mover a Finalizado"
											v-if="row.TskStatus == 5">
											<v-list-item-icon>
												<v-icon>mdi-arrow-left-circle</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Mover a Finalizado</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="clickConditionTask(row)"
											aria-label="Ver condición de tarea" v-if="$fun.isAdmin()">
											<v-list-item-icon>
												<v-icon>mdi-information-outline</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Ver condición</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="AsgWorkerName(row)" aria-label="Asignar trabajador"
											v-if="$fun.isAdmin()">
											<v-list-item-icon>
												<v-icon>mdi-account-plus-outline</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Asignar a trabajador</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="TskHistory(row)" aria-label="Ver Historial">
											<v-list-item-icon>
												<v-icon>mdi-eye-outline</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Ver Historial</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="TskTransfer(row)" aria-label="Ver Historial">
											<v-list-item-icon>
												<v-icon>mdi-folder-move-outline</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Mover actividad</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-card>
							</v-menu>
						</template>

						<!-- Columna de Acciones Rápidas -->
						<template v-slot:TskQuickActions="{ row }">
							<div class="d-flex gap-1">
								<!-- Botón Iniciar -->
								<v-tooltip bottom v-if="row.TskStatus == 1">
									<template v-slot:activator="{ on }">
										<v-btn small v-on="on" icon color="success" @click="clickActionTask(row)">
											<v-icon small>mdi-play</v-icon>
										</v-btn>
									</template>
									<span>Iniciar</span>
								</v-tooltip>

								<!-- Botón Finalizar -->
								<v-tooltip bottom v-if="row.TskStatus == 2 && row.TskPaused == 0">
									<template v-slot:activator="{ on }">
										<v-btn v-on="on" small icon color="error" @click="clickActionTask(row)">
											<v-icon small>mdi-stop</v-icon>
										</v-btn>
									</template>
									<span>Finalizar</span>
								</v-tooltip>

								<!-- Botón Pausar/Reanudar -->
								<v-tooltip bottom v-if="row.TskStatus != 1 && row.TskStatus != 3 && row.TskStatus != 5">
									<template v-slot:activator="{ on }">
										<v-btn v-on="on" small icon :color="row.TskPaused == 1 ? 'teal' : 'orange'"
											@click="clickPausedTask(row)">
											<v-icon small>{{ row.TskPaused == 1 ? 'mdi-play-circle-outline' :
												'mdi-pause-circle-outline' }}</v-icon>
										</v-btn>
									</template>
									<span>{{ row.TskPaused == 1 ? 'Reanudar' : 'Pausar' }}</span>
								</v-tooltip>

								<!-- Botón Producción -->
								<v-tooltip bottom v-if="row.TskStatus == 3">
									<template v-slot:activator="{ on }">
										<v-btn v-on="on" small icon color="primary" @click="clickProductionTask(row)">
											<v-icon small>mdi-cloud-upload</v-icon>
										</v-btn>
									</template>
									<span>Subir a Producción</span>
								</v-tooltip>

								<v-tooltip bottom v-if="row.TskStatus == 5">
									<template v-slot:activator="{ on }">
										<v-btn v-on="on" small icon color="warning" @click="clickProductionTask(row)">
											<v-icon small>mdi-arrow-left-circle</v-icon>
										</v-btn>
									</template>
									<span>Regresar a Finalizado</span>
								</v-tooltip>
							</div>
						</template>

						<template v-slot:Print="{ row }">
							<v-btn x-small dark :color="'success'"
								style="border-radius: 13px; margin: 10px 10px 10px 10px;" @click="clickPrint(row)">
								<v-icon>mdi-printer</v-icon>
							</v-btn>
						</template>

					</s-crud>
				</v-col>
			</v-row>
		</div>

		<!-- Modal (v-dialog) -->
		
		<TaskWorkerTransferModal 
			v-model="dialogWorkerTransfer" 
			:tasks="selected" 
			:workers="workerstic" 
			@transferred="$refs.gridtask.refresh()" 
		/>
		
		<!--condition tabla-->
		<!-- <v-dialog v-model="modalCondition" max-width="600px" ref="tblCondicion">
		<v-card>
			<v-card-title class="headline primary" style="color: white;">
			Seleccionar condiciones:
			<v-btn text color="white" @click="FunAdd()">
				<v-icon>mdi-plus</v-icon>
			</v-btn>
			</v-card-title>

			<v-card-subtitle class="pa-5">
			<div v-if="showInputField" class="mt-1 bordered-div">
				<v-row>
				<v-col>
					<s-text class="s-col-form" placeholder="Nueva condición" v-model="newConditionName"></s-text>
				</v-col>
				<v-col>
					<v-btn color="primary" @click="registrarCondicion">Registrar</v-btn>
				</v-col>
				</v-row>
			</div>

			<s-text class="pa-1" placeholder="Buscar por condición" append-icon="mdi-magnify" search-icon v-model="filterText"></s-text>

			<v-simple-table dense class="pa-1">
				<thead>
				<tr>
					<th></th>
					<th>Condiciones</th>
					<th>Accion</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="condition in filteredConditions" :key="condition.TskID"  >
					<td style="width: 50px;">
					<v-checkbox
						v-model="condition.selected"
						:value="condition.selected"
						:id="String(condition.TkcID)"
						hide-details
						class="ma-0"
					></v-checkbox>
					</td>
					<td class="pa-0" @click="selectCondition(condition)" >{{ condition.TkcName }}</td>
					<td class="pa-0"><v-btn text color="grey" @click="FunctDelete(condition)"><v-icon>mdi-delete</v-icon></v-btn></td>
				</tr>
				</tbody>
			</v-simple-table>

			<v-pagination v-model="page" :length="totalPages" :total-visible="5" class="mt-4"></v-pagination>

			<v-progress-linear
				:value="progressPercentage"
				height="20"
				color="blue"
				class="mt-4"
				striped
			>
			
				<template v-slot:default>
				<div class="text-center" style="width: 100%; position: absolute; top: 50%; transform: translateY(-50%);color:white;">
					{{ progressPercentage.toFixed(2) }}%
				</div>
				</template>
			</v-progress-linear>
			</v-card-subtitle>

			<v-card-actions>
			<v-btn text color="error" @click="CerrarModalCondition()">Cerrar</v-btn>
			<v-btn text color="primary" @click="guardarSeleccion">Guardar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog> -->

		<v-dialog persistent v-if="modalCondition" v-model="modalCondition" max-width="600px">
			<Task-Condition :item="newData" @close="CerrarModalCondition"></Task-Condition>
		</v-dialog>

		<v-dialog v-model="OpenHistory" width="600" persistent v-if="OpenHistory">
			<TaskHistory :item="dataHistory" @close="OpenHistory = false"></TaskHistory>
		</v-dialog>
		
		<TaskWorkerTransferModal v-model="dialogTransfer" :task="selected.length > 0 ? selected[selected.length - 1] : {}" :workers="workerstic" @transferred="$refs.gridtask.refresh()" />
		<TaskPauseModal v-model="dialogPaused" :task="selected.length > 0 ? selected[selected.length - 1] : {}" @paused="$refs.gridtask.refresh()" />
		<TaskSummaryModal v-model="dialogResult" :areID="filter.AreID" />
		<TaskActiveProcessModal v-model="dialogProccess" />
		<TaskUsersModal v-model="dialogUsers" :itemSelectedSave="itemSelectedSave" />
		<TaskProjectTransferModal v-model="transferDialog" :tasks="selectedTask ? [selectedTask] : selected" :projects="Proyectic" :currentProjectId="proyect.TkpID" @transferred="$refs.gridtask.refresh()" />
		<TaskImportModal v-model="showImportModal" :filterTkpID="filter.TkpID" :proyectTkpTitle="proyect.TkpTitle" @imported="$refs.gridtask.refresh()" />
		<TaskEmailPreviewModal v-model="dialogPreviewMail" :task="selected.length > 0 ? selected[selected.length - 1] : {}" />

		<AlertSunshine :dialog="dialogLoading" :totalItems="totalItems" :countItems="countItems" />

	</div>
</template>

<script>
import _sTaskService from '@/services/InformationTechnology/TaskService.js';
import _sTaskUsersService from '@/services/InformationTechnology/TaskUsersService.js';
import _sGenParamService from "@/services/General/ParameterService";
import sTextarea from '../../../components/Utils/sTextarea.vue';
import sSelectAssigned from '../../../components/Utils/SSelectAssigned.vue';
import sSelectEquipmentSerie from '../../../components/Utils/sSelectEquipmentSerie.vue';
import { isUndefined } from 'lodash';
import _sGeneral from "@/services/HelperService.js";
import _sHelper from "@/services/HelperService";
import sUser from "@/views/Security/UserOption/User.vue";
import _sDefinition from "@/services/General/DefinitionService.js";
import TaskHistory from './TaskHistory.vue';
import TaskCondition from './TaskCondition.vue';
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import qrCode from "vue-qr-generator";
import HoursReport from '@/services/HumanResource/HoursReport';

import TaskImportModal from './TaskImportModal.vue';
import TaskEmailPreviewModal from './TaskEmailPreviewModal.vue';
import TaskProjectTransferModal from './TaskProjectTransferModal.vue';
import TaskWorkerTransferModal from './TaskWorkerTransferModal.vue';
import TaskPauseModal from './TaskPauseModal.vue';
import TaskSummaryModal from './TaskSummaryModal.vue';
import TaskActiveProcessModal from './TaskActiveProcessModal.vue';
import TaskUsersModal from './TaskUsersModal.vue';
import ProjectSidebar from './ProjectSidebar.vue';

export default {
	components: { sTextarea, sUser, sSelectAssigned, TaskCondition, TaskHistory, sToolbarPerson, TaskImportModal, TaskEmailPreviewModal, TaskProjectTransferModal, TaskWorkerTransferModal, TaskPauseModal, TaskSummaryModal, TaskActiveProcessModal, TaskUsersModal, ProjectSidebar, sSelectEquipmentSerie },
	data() {
		return {
			loadingData: false,
			allowEditFinalizedTask: false,
			dialogUsers: false,
			requiresMaintenance: false,
			searchAre: true,
			Attach1: null,
			dialogTable: true,
			TkpStatus: null,
			TkcID: 0,
			proyect: {},
			dialogTransfer: false,
			dialogPaused: false,
			dialogResult: false,
			selected: [],
			workerstic: [],
			targetTic: [],
			ConditionTic: [],
			Proyectic: [],
			dialogProccess: false,
			TksIDi: 0,
			modalCondition: false,
			SecStatus: 1,
			OpenHistory: false,
			dataHistory: {},
			itemsWeek: [],
			years: [],
			filter: {
				PrsID: 0,
				IsAdmin: this.$fun.isAdmin() ? 1 : 0,
				TkpID: 0,
				TypeClasification: null
			},
			filterUser: {
				TskID: 0
			},
			page: 1, // Página actual
			perPage: 10, // Elementos por página
			filterText: '', // Texto de filtro
			showInputField: false,
			newConditionName: '',
			configSearch: {
				model: {
					PrsID: "ID",
					NtpFullName: "NtpFullName"
				},
				service: _sTaskUsersService,
				headers: [
					{ text: "ID", value: "PrsID" },
					{ text: "Apellidos y Nombres", value: "NtpFullName" }
				]
			},
			itemsSearch: [],
			selectedSearch: [],
			config: {
				model: {
					TskID: "ID",
					Action: "Action",
					ConditButt: "ConditButt",
					TskStatus: "integer",
					TskPriority: "integer",
					NameTypeTask: "integer",
					FilePathDownload: "FilePathDownload",
					AsgWorkerName: "",
					TskRequestDate: "datetime",
					Print: "",
				},
				service: _sTaskService,
				headers: [
					{ text: "Opciones", value: "TskMultiple" },
					{ text: "Acciones", value: "TskQuickActions", width: 50 },
					{ text: "ID", value: "TskID" },
					{ text: "Estado", value: "TskStatus" },
					{ text: "Titulo", value: "TskTitle" },
					{ text: "Tipo", value: "TypeClasificationName" },
					{ text: "Archivo", value: "FilePathDownload" },
					{ text: "Objetivo", value: "TargetName" },
					{ text: "Prioridad", value: "TskPriority" },
					{ text: "Criticidad", value: "TskCriticalityName" },
					{ text: "F. Solicitud", value: "TskRequestDate" },
					{ text: "Abierto", value: "TskDateName" },
					{ text: "Tipo Registro", value: "NameTypeTask" },

					// { text: "F. Ini", value: "TskDateBeginName" },
					// { text: "F. Fin", value: "TskDateEndName" }
					{ text: "Area de Tarea", value: "AreNameTask" },
					{ text: "Usuario Solicitante", value: "NtpFullNameAttended" },
					{ text: "Print", value: "Print", width: 10 },
				]
			},
			itemSelectedSave: {},
			selectedFilter: 2,
			filters: [],
			newData: {},
			transferDialog: false,
			dialogWorkerTransfer: false,
			selectedTask: null,
			showImportModal: false,
			dialogPreviewMail: false,
			totalItems: 0,
			countItems: 0,
			dialogLoading: false,
		}
	},
	computed: {
		filtereditemsSearch() {
			return this.itemsSearch.filter(item => item.SecStatus !== 0);
		},
		filteredConditions() {
			// Filtramos las condiciones según el texto de búsqueda
			const filtered = this.ConditionTic.filter(condition =>
				condition.TkcName.toLowerCase().includes(this.filterText.toLowerCase())
			);
			return filtered.slice((this.page - 1) * this.perPage, this.page * this.perPage);
		},
		totalPages() {
			// Calculamos cuántas páginas serán necesarias
			const filteredCount = this.ConditionTic.filter(condition =>
				condition.TkcName.toLowerCase().includes(this.filterText.toLowerCase())
			).length;
			return Math.ceil(filteredCount / this.perPage);
		},
		progressPercentage() {
			// Filtramos las condiciones visibles
			const totalVisibleConditions = this.filteredConditions.length;
			const selectedConditions = this.filteredConditions.filter(condition => condition.selected).length;

			// Si no hay condiciones visibles, no hay progreso
			if (totalVisibleConditions === 0) return 0;

			// Calculamos el porcentaje
			return (selectedConditions / totalVisibleConditions) * 100;
		},
		selectedProject() {
			if (this.selectedProjectIndex !== null && this.selectedProjectIndex !== undefined) {
				return this.availableProjects[this.selectedProjectIndex];
			}
			return null;
		},
		isSelectedTaskFinalized() {
			if (!this.selected || this.selected.length === 0) return false;
			const lastItem = this.selected[this.selected.length - 1];
			return lastItem.TskStatus === 3;
		},
	},
	watch: {
		filter() {
			console.log(this.filter)
		},
	},
	methods: {
		returnPerson(value, item) {
			item.NtpFullNameAttended = value.NtpFullName;
			item.PrsDocumentNumberAttended = value.PrsDocumentNumber;
			item.NtpIDAttended = value.NtpID;
			item.PrsIDAttended = value.PrsID;
			item.AreIDTask = value.AreID;
			item.AreNameTask = value.AreName;
			this.searchAre = false;
			this.$nextTick(() => {
				this.searchAre = true;
			});
		},
		onAddEvent(item) {
			item.PrsID = this.$fun.getUserInfo().PrsID;
			item.TskAttentionChannel = null;
			item.TskLocation = null;
			item.TskTechnicalCategory = null;
			item.TskIsRecurring = false;
		},
		onGenerateMaintenance(item) {
			console.log("Generate maintenance for task", item.TskID);
		},
		filterProjects(filter) {
			this.selectedFilter = filter;
			// Aquí implementa la lógica de filtrado de proyectos
			this.getTicProyects();
		},
		loadDefinition() {
			_sDefinition.definitiongroup(1393, 0, this.$fun.getUserID()).then((r) => {
				this.filters = r.data.map(item => ({
					label: item.DedDescription,
					value: item.DedValue,
					helper: item.DedHelper
				}));
			});
		},
		selectCondition(condition) {
			console.log("selectcondi", condition);
			this.TkcID = condition.TkcID;
			this.showInputField = true;
			this.newConditionName = condition.TkcName;
		},
		FunctDelete(condition) {
			this.TkcID = condition.TkcID;
			this.newConditionName = condition.TkcName;
			this.SecStatus = 0;
			this.registrarCondicion();
		},
		AsgDeleteSchedule() {
			// console.log("this.selectedSearch:",this.selectedSearch);
			if (this.selectedSearch[0].TtuID == null) {
				this.itemsSearch.splice(this.itemsSearch.indexOf(this.selectedSearch[0]), 1);
			} else {
				// console.log("this.selectedSearchRemove:",this.selectedSearch[0]);
				const index = this.itemsSearch.indexOf(this.selectedSearch[0]);
				if (index !== -1) {
					this.itemsSearch[index].SecStatus = 0;
				}
			}

			this.selectedSearch = [];
		},
		saveUsers() {
			// console.log("saveUsers:",this.itemsSearch);
			this.itemSelectedSave.itemsDetail = this.itemsSearch;
			this.itemSelectedSave.UsrUpdateID = this.$fun.getUserID();
			// console.log("itemSelectedSave:",this.itemSelectedSave);
			_sTaskService.save(this.itemSelectedSave, this.$fun.getUserID())
				.then(resp => {
					// console.log("resp:",resp);
					if (resp.status == 200) {
						this.$fun.alert("Actualizado correctamente", "success");
						this.$refs.gridtask.refresh();
						this.dialogUsers = false;
					}
				})
		},
		saveUserPermit() {
			this.usersCopy = Object.assign([], this.usersCopy).filter((x) => x.UsrID != "");
			// console.log("this.usersCopy:",this.usersCopy);
			// console.log("this.itemsSearch:",this.itemsSearch);
			this.dialogUsersAdd = false;
			if (this.usersCopy.length > 0) {
				for (let i = 0; i < this.usersCopy.length; i++) {
					const prsID = this.usersCopy[i].PrsID;

					const exists = this.itemsSearch.some(item => item.PrsID == prsID);
					// console.log("exists:",exists);
					if (!exists) {
						const itemNew = {
							PrsID: prsID,
							UsrCreateID: this.$fun.getUserID(),
							NtpFullName: this.usersCopy[i].NtpFullName
						};
						this.itemsSearch.push(itemNew);
					}
				}
			}

			if (this.itemsSearch.length > 0) {
				for (var i = 0; i < this.itemsSearch.length; i++) {
					this.itemsSearch[i].UsrCreateID = this.$fun.getUserID();
				}
			}
			// console.log("this.itemsSearch:", this.itemsSearch);
		},
		addNewUsers() {
			this.dialogUsersAdd = true;
			this.usersCopy = [];
			// this.$refs.usrcopy.refresh();
		},
		AsgWorkerName(row) {
			this.filterUser.TskID = row.TskID;
			this.itemSelectedSave = row;
			// if(row.itemsDetail != null){
			// 	row = JSON.parse(row.itemsDetail);
			// 	this.itemsSearch = row;	
			// }else{
			// 	this.itemsSearch = [];
			// }
			this.dialogUsers = true;
		},
		rowClickSearch: function (item, row) {
			// console.log("item Desde la tabla:",item);
			if (item !== undefined) {
				if (item == this.selectedSearch[0]) {
					this.selectedSearch = [];
				} else {
					this.selectedSearch = [item];
				}
			}
		},
		enviarProyecto(proyect) {
			this.TkpStatus = proyect.TkpStatus;
			// console.log("this.TkpStatus", this.TkpStatus);
			this.proyect = proyect;
			this.filter.TkpID = proyect.TkpID;
			this.getTicTarget();
		},
		sendMail(task) {
			_sTaskService
				.sendmail(task, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						this.$fun.alert("Enviado correctamente", "success");
						return;
					}
				})
		},

		initialize() {
			this.loadDefinition();
			this.filterProjects(2);
			this.getTicWorkers();
			this.getTicProyects();
			this.loadAllowEditFinalizedTaskParameter();
		},
		loadAllowEditFinalizedTaskParameter() {
			_sGenParamService.search({ PrmName: "TicAllowEditFinalizedTask" }, this.$fun.getUserID())
				.then(resp => {
					if (resp.data != null) {
						this.allowEditFinalizedTask = parseInt(resp.data.PrmValue) === 1;
					}
				})
				.catch(error => {
					console.error("Error al obtener parámetro TicAllowEditFinalizedTask:", error);
				});
		},

		async save(item) {

			if (isUndefined(item.PrsID) || item.PrsID === 0) item.PrsID = this.$fun.getUserInfo().PrsID;
			item.AreID = this.filter.AreID;
			item.TkpID = this.filter.TkpID;
			if (this.filter.TkpID == 0 || this.filter.TkpID == undefined) {
				this.$fun.alert("Seleccione un proyecto", "warning");
				return;
			}

			if (item.TskStatus === 3 && !this.allowEditFinalizedTask) {
				this.$fun.alert("No se puede editar una tarea que ya está finalizada", "warning");
				return;
			}

			if (item.SecStatus == null) item.SecStatus = 1;

			item.UsrCreateID = this.$fun.getUserID();
			item.FilePath = this.Attach1 != null ? this.Attach1.name : "";
			item.TskValidateRequiredTime = item.TskValidateRequiredTime ? 1 : 0;
			item.TskIsRecurring = item.TskIsRecurring ? true : false;

			item.itemsDetail = [
				{
					UsrCreateID: this.$fun.getUserID(),
					PrsID: item.PrsID
				}
			];

			if (this.Attach1 instanceof File) {

				let files = [this.Attach1];
				let formData = new FormData();

				files.forEach((element, index) => {
					formData.append(index.toString(), element);
				});

				_sGeneral.uploadfile("TicTask", this.$fun.getUserID(), formData, 3)
					.then(response => {
						if (response.status === 200) {
							console.log("Archivo subido correctamente");
						}
					});
			}
			console.log("item", JSON.parse(JSON.stringify(item)));
			try {
				await new Promise((resolve, reject) => {
					if (typeof item.save === "function") {
						const result = item.save();
						if (result instanceof Promise) {
							result.then(resolve).catch(reject);
						} else {
							resolve(result);
						}
					} else {
						reject(new Error("item.save no es una función"));
					}
				});
				// console.log("saveeeeeeee");
			} catch (error) {
				console.error("Error al guardar el item:", error);
			}

			this.dialogTable = false;
			setTimeout(() => {
				this.dialogTable = true;
			}, 10);
		},
		openFile(nameFile) {
			_sGeneral.download(nameFile, this.$fun.getUserID()).then((r) => {
				if (r.status === 200) {
					// console.log("Imprime :", r);
					this.$fun.downloadHttp(r);
				}
			});
		},
		FunAdd() {
			this.TkcID = 0;
			this.SecStatus = 1;
			this.showInputField = !this.showInputField;
		},

		// Función para registrar la nueva condición
		registrarCondicion() {
			if (this.newConditionName) {
				// Aquí deberías agregar la lógica para guardar la nueva condición
				// console.log("Nueva condición registrada: ", this.newConditionName);

				let obj = {
					TkcID: this.TkcID,
					TskID: this.TksIDi,
					TkcName: this.newConditionName,
					SecStatus: this.SecStatus,
					UsrCreateID: this.$fun.getUserID(),
					TkcStatus: 0
				}
				_sTaskService.saveCondition(obj, this.$fun.getUserID())
					.then(resp => {
						if (resp.status == 200) {
							this.$fun.alert("Accion realizada con exito", "success");
							this.showInputField = !this.showInputField;
							this.newConditionName = '';
							this.getTicCondition(this.TksIDi);
						}
					});

			}
		},
		getTicWorkers() {
			let obj = {
				AreID: this.filter.AreID
			}
			_sTaskService
				.ticworkers(obj, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						// console.log('work', resp.data)
						this.workerstic = resp.data;
					}
				})
		},
		getTicTarget() {
			let obj = {
				TkpID: this.filter.TkpID
			}
			_sTaskService
				.ticTargetbyProy(obj, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						// console.log('target', resp.data)
						this.targetTic = resp.data;
					}
				})
		},
		CerrarModalCondition() {
			this.showInputField = false;
			this.modalCondition = false;
			this.page = 1;
		},
		getTicCondition(TskID) {
			let obj = {
				TskID: TskID
			}
			_sTaskService
				.ticConditionByTask(obj, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						// console.log('condiiton', resp.data)
						this.ConditionTic = resp.data;
						this.ConditionTic.forEach(condition => {
							condition.selected = condition.TkcStatus > 0 ? true : false; // Si TkcID es 1, está seleccionado
							// console.log(condition.TkcStatus);
						});
					}

				});
		},
		getTictaskStaList() {
			let obj = {
				TskStatus: 2,
				UsrID: this.$fun.getUserID()
			}
			_sTaskService
				.tictaskBystatusTask(obj, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						this.tictaStatusList = resp.data;
					}
				});
		},
		getTicSummary() {
			this.loadingData = true;
			let obj = {
				AreID: this.filter.AreID,
				DateBegin: this.BeginDate,
				DateEnd: this.EndDate
			}
			_sTaskService
				.ticketSummary(obj, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						// console.log('sum', resp.data)
						this.summarytic = resp.data;
					}
					this.loadingData = false;
				})
		},
		getTicGeneralSummary() {
			let obj = {
				AreID: this.filter.AreID,
				DateBegin: this.BeginDate,
				DateEnd: this.EndDate
			}
			console.log("obj", obj);
			_sTaskService
				.ticketGeneralSummary(obj, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						// console.log('sum', resp.data)
						this.Gensummarytic = resp.data;
					}
				})
		},
		downloadExcel() {
			console.log("Dataaaaaaaaaaaaaaa:", this.Gensummarytic);
			this.$fun.alert("¿Seguro de descargar?", "question")
				.then(r => {
					if (r.value) {
						_sTaskService
							.convertexcel(this.Gensummarytic, this.$fun.getUserID())
							.then(resp => {
								this.$fun.downloadFile(resp.data, this.$const.TypeFile.EXCEL, this.$fun.getUserID());
							})
					}
				})
		},
		getTicProyects() {
			let obj = {
				AreID: this.filter.AreID,
				UsrID: this.$fun.getUserID(),
				TkpStatus: this.selectedFilter
			}
			_sTaskService.ticproyect(obj, this.$fun.getUserID()).then(resp => {
				if (resp.status == 200) {
					// console.log('proyect', resp.data)
					this.Proyectic = resp.data;
				}
			});
		},
		guardarSeleccion() {
			// Función para guardar las selecciones
			const selectedConditions = this.ConditionTic.filter(condition => condition.selected);
			const sconcatenatedString = selectedConditions.map(condition => condition.TkcID).join(", ");
			// console.log("aqui",sconcatenatedString); 
			const unselectedConditions = this.ConditionTic.filter(condition => !condition.selected);
			const uconcatenatedString = unselectedConditions.map(condition => condition.TkcID).join(", ");
			// console.log("Condiciones no seleccionadas:", uconcatenatedString);

			let obj = {
				TskID: this.TksIDi,
				SecStatus: 1,
				UsrCreateID: this.$fun.getUserID(),
				TkcIDT: sconcatenatedString,
				TkcIDF: uconcatenatedString
			}
			_sTaskService
				.TicTaskConditionTask(obj, this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						this.$fun.alert("Actualizado correctamente", "success");
						this.modalCondition = false;
					}
				});
		},
		clickConditionTask(item) {
			this.newData = {};
			this.modalCondition = true;
			this.newData.TskID = item.TskID;
		},
		close() {
			this.newData = {};
			this.modalCondition = false;
		},

		clickActionTask(item) {
			let message = ''
			let valueTasks = 0;
			if (item.TskStatus == 1) {
				message = '¿Seguro de iniciar?'
				item.TskDateBegin = '1999-09-09 10:00:50.747';
				valueTasks = 2;
			}
			else {
				message = '¿Seguro de finalizar?'
				item.TskDateEnd = '1999-09-09 10:00:50.747';
				valueTasks = 3;
			}

			this.$fun.alert(message, "question")
				.then(r => {
					if (r.value) {
						item.TskStatus = valueTasks;
						item.SecStatus = valueTasks ? 1 : item.SecStatus;
						item.UsrUpdateID = this.$fun.getUserID();
						_sTaskService
							.save(item, this.$fun.getUserID())
							.then(resp => {
								if (resp.status == 200) {
									if (item.TskStatus = 2) {
										this.sendMail(item);
									}
									this.$fun.alert("Actualizado correctamente", "success");
									this.$refs.gridtask.refresh();
								}
							})
					}
				})

		},
		clickPausedTask(item) {
			this.$fun.alert(`¿Seguro de ${item.TskPaused == 1 ? "reanudar" : "pausar"}?`, "question")
				.then(r => {
					if (r.value) {
						item.TskPaused = item.TskPaused == 1 ? 0 : 1;
						item.TskStatus = item.TskPaused === 1 ? 6 : 2;
						item.PrsID = this.$fun.getUserInfo().PrsID;
						_sTaskService
							.save(item, this.$fun.getUserID())
							.then(resp => {
								if (resp.status == 200) {
									this.$fun.alert("Actualizado correctamente", "success");
									this.$refs.gridtask.refresh();
								}
							})
					}
				})

		},
		clickProductionTask(item) {
			let message = ''
			let valueTasks = 0;
			if (item.TskStatus == 3) {
				message = '¿Seguro de subir a producción?';
				valueTasks = 5;
			} else {
				message = '¿Seguro de regresar a finalizado?';
				valueTasks = 3;
			}

			this.$fun.alert(message, "question")
				.then(r => {
					if (r.value) {
						item.TskStatus = valueTasks;
						item.SecStatus = 1;
						item.UsrUpdateID = this.$fun.getUserID();
						_sTaskService
							.save(item, this.$fun.getUserID())
							.then(resp => {
								if (resp.status == 200) {
									this.$fun.alert("Actualizado correctamente", "success");
									this.$refs.gridtask.refresh();
								}
							})
					}
				})
		},
		async bulkProductionTask() {
			if (this.selected.length === 0) {
				this.$fun.alert("Seleccione al menos una tarea", "warning");
				return;
			}

			// Validar que todas sean 3 o 5
			const invalidTasks = this.selected.filter(t => t.TskStatus !== 3 && t.TskStatus !== 5);
			if (invalidTasks.length > 0) {
				this.$fun.alert("Las tareas seleccionadas deben estar en estado Finalizado (3) o En Producción (5)", "warning");
				return;
			}

			this.$fun.alert(`¿Seguro de cambiar el estado de las ${this.selected.length} tareas seleccionadas?`, "question")
				.then(async r => {
					if (r.value) {
						try {
							for (const item of this.selected) {
								let valueTasks = item.TskStatus == 3 ? 5 : 3;
								item.TskStatus = valueTasks;
								item.SecStatus = 1;
								item.UsrUpdateID = this.$fun.getUserID();
								await _sTaskService.save(item, this.$fun.getUserID());
							}
							this.$fun.alert("Tareas actualizadas correctamente", "success");
							this.$refs.gridtask.refresh();
							
							if (this.$refs.gridtask) {
								this.$refs.gridtask.selected = [];
							}
							this.selected = [];
						} catch (error) {
							console.error("Error al actualizar tareas:", error);
							this.$fun.alert("Ocurrió un error al actualizar algunas tareas", "error");
						}
					}
				});
		},
		TskHistory(item) {
			this.dataHistory = {};
			this.dataHistory = item;
			this.OpenHistory = true;
		},
		opendialogResult() {
			this.dialogResult = true;
		},
		opendialogTaskProceso() {
			this.dialogProccess = true;
			this.getTictaskStaList();
		},
		transferTask() {
			if (this.selected.length === 0) return;
			const selected = this.selected[0];
			if (selected.TskStatus != 1 && selected.TskStatus != 2) {
				this.$fun.alert("La tarea ya fue finalizada o transferida", "info");
				return;
			}
			this.dialogTransfer = true;
		},
		pausedTask() {
			if (this.selected.length === 0) return;
			const selected = this.selected[0];
			if (selected.TskStatus != 1 && selected.TskStatus != 2) {
				this.$fun.alert("La tarea ya fue finalizada o transferida", "info");
				return;
			}
			if (selected.TskPaused == 1) {
				this.$fun.alert("¿Seguro de reanudar tarea?", "question")
					.then(r => {
						if (r.value) {
							selected.TskStatus = 104;
							selected.UsrUpdateID = this.$fun.getUserID();
							_sTaskService
								.save(selected, this.$fun.getUserID())
								.then(resp => {
									if (resp.status == 200) {
										this.$fun.alert("Reanudada correctamente", "success");
										this.$refs.gridtask.refresh();
										this.dialogPaused = false;
										return;
									}
								})
						}
					})
				return;
			}
			if (selected.TskPaused == 0) {
				this.dialogPaused = true;
			}

		},
		
		
		sendPaused() {
			if (this.selected.length === 0) return;
			const selected = this.selected[0];
			selected.TskStatus = 103;
			selected.UsrUpdateID = this.$fun.getUserID();
			selected.TskReasonTraslate = this.dataPaused.TskReasonTraslate;
			this.$fun.alert("¿Seguro de pausar?", "question")
				.then(r => {
					if (r.value) {
						_sTaskService
							.save(selected, this.$fun.getUserID())
							.then(resp => {
								if (resp.status == 200) {
									this.$fun.alert("Pausado correctamente", "success");
									this.$refs.gridtask.refresh();
									this.dialogPaused = false;
									return;
								}
							})
					}
				})
		},
		
		sendTransfer() {
			if (this.selected.length === 0) return;
			const selected = this.selected[0];
			if (selected.PrsID == this.datatransfer.PrsIDTraslate) {
				this.$fun.alert("No se puede trasladar a la misma persona", "info");
				return;
			}
			this.$fun.alert("¿Seguro de transferir?", "question")
				.then(r => {
					if (r.value) {
						selected.PrsIDTraslate = this.datatransfer.PrsIDTraslate;
						selected.TskReasonTraslate = this.datatransfer.TskReasonTraslate;
						selected.UsrUpdateID = this.$fun.getUserID();
						selected.TskStatus = 102

						_sTaskService
							.save(selected, this.$fun.getUserID())
							.then(resp => {
								if (resp.status == 200) {
									this.$fun.alert("Transferido correctamente", "success");
									this.$refs.gridtask.refresh();
									this.dialogTransfer = false;
								}
							})
					}
				})

		},
		rowSelected(items) {
			this.Attach1 = null;
			this.selected = items;

			if (items.length > 0) {
				const lastItem = items[items.length - 1];
				this.TskTimeRequired = lastItem.TskTimeRequired ?? lastItem.TskDuration;
				this.TskValidateRequiredTime = lastItem.TskValidateRequiredTime == 1 ? true : false;

				if (lastItem.FilePath) {
					this.Attach1 = { name: lastItem.FilePath };
				} else {
					this.Attach1 = null;
				}
			}
		},
		
		saveTaskUser(item) {
			item.TskID = this.itemSelectedSave.TskID;
			item.UsrCreateID = this.$fun.getUserID();
			item.UsrUpdateID = this.$fun.getUserID();
			this.$fun.alert("Seguro de Guardar?", "question")
				.then(r => {
					if (r.value) {
						_sTaskUsersService.save(item, this.$fun.getUserID())
							.then(resp => {
								if (resp.status == 200) {
									this.$fun.alert("Se agrego correctamente", "success");
									this.$refs.ScrudTaskUsers.refresh();
								}
							});
					}
				});
		},
		
		
		async confirmTransfer() {
			if (!this.selectedProject) {
				return;
			}

			const itemsToTransfer = this.selectedTask ? [this.selectedTask] : this.selected;
			const count = itemsToTransfer.length;

			this.$fun.alert(`¿Seguro de transferir ${count > 1 ? count + ' tareas' : 'esta tarea'} a ${this.selectedProject.TkpTitle}?`, "question")
				.then(async r => {
					if (r.value) {
						this.transferring = true;

						try {
							for (const task of itemsToTransfer) {
								const transferData = {
									TskID: task.TskID,
									TkpID: this.selectedProject.TkpID,
									TskReasonTraslate: this.transferReason,
									PrsIDTraslate: this.$fun.getUserInfo().PrsID,
									UsrUpdateID: this.$fun.getUserID()
								};
								await _sTaskService.transfer(transferData, this.$fun.getUserID());
							}

							this.$fun.alert(`${count > 1 ? count + ' tareas transferidas' : 'Tarea transferida'} correctamente al proyecto ${this.selectedProject.TkpTitle}`, 'success');
							this.$refs.gridtask.refresh();
							this.$refs.gridtask.selected = [];
							this.transferDialog = false;
						} catch (error) {
							console.error("Error en transferencia:", error);
							this.$fun.alert("Error al transferir algunas tareas", "error");
						} finally {
							this.transferring = false;
							this.selected = [];
							this.$refs.gridtask.selected = [];
						}
					}
				});
		},
		openDialogTask() {
			this.showImportModal = true;
		},
		bulkTransferWorkerTask() {
			if (this.selected.length === 0) {
				this.$fun.alert("Seleccione al menos una tarea", "warning");
				return;
			}
			
			// Validar que ninguna tarea esté finalizada (estado 3)
			const finishedTasks = this.selected.filter(t => t.TskStatus === 3);
			if (finishedTasks.length > 0) {
				this.$fun.alert("No se pueden transferir tareas que ya están finalizadas", "warning");
				return;
			}

			this.dialogWorkerTransfer = true;
		},
		bulkTransferTask() {
			if (this.selected.length === 0) {
				this.$fun.alert("Seleccione al menos una tarea", "warning");
				return;
			}
			this.selectedTask = null; // Indica que es en bloque
			this.currentProjectId = this.proyect.TkpID;
			this.selectedProjectIndex = null;
			this.transferReason = "";
			this.loadAvailableProjects();
			this.transferDialog = true;
		},
		TskTransfer(task) {
			this.selectedTask = task;
			this.currentProjectId = this.proyect.TkpID; // ID del proyecto actual
			this.selectedProjectIndex = null;
			this.loadAvailableProjects();
			this.transferDialog = true;
		},
		loadAvailableProjects() {
			// Usar la misma lista de proyectos que ya tienes
			this.availableProjects = this.Proyectic.filter(project => {
				// Opcional: filtrar proyectos según permisos o estado
				return project.TkpStatus !== 3; // No incluir proyectos cerrados
			});
		},
		cancelTransfer() {
			this.transferDialog = false;
			this.selectedTask = null;
			this.selectedProjectIndex = null;
		},
		
		clickPrint(item) {

			if (!item) {
				this.$fun.alert("Seleccione un item del Listado", "warning");
				return;
			}

			const ticketId = item.TskID;
			const tskTitle = item.TskTitle;
			// console.log('titulo print');
			// console.log(tskTitle);
			// console.log(item);
			const Pagelink = "about:blank";
			const pwa = window.open(Pagelink, "_new");

			pwa.document.open();
			pwa.document.write(`
				<html>
				<head>
				<title>Ticket-${ticketId}</title>

				<script src="https://cdn.jsdelivr.net/npm/qrcodejs/qrcode.min.js"><\/script>

				<script>
					function step1(){
					setTimeout(step2, 500);
					}
					function step2(){
					window.print();
					window.close();
					}
				<\/script>

				<style>
					body {
					font-family: Arial, sans-serif;
					}

					.ticket-container {
					display: flex;
					align-items: center;
					gap: 20px;
					margin: 40px;
					}

					.ticket-text h2 {
					margin: 0;
					font-size: 40px;
					}

					.ticket-text p {
					margin-top: 5px;
					font-size: 40px;
					}

					@media print {
					@page {
						margin: 2cm;
					}
					}
				</style>
				</head>

				<body onload="step1()">
				<div class="ticket-container">
					<div id="qrcode"></div>

					<div class="ticket-text">
					<h2>TICKET</h2>
					<p>ID: ${ticketId}</p>
					</div>
				</div>

				<script>
					new QRCode(document.getElementById("qrcode"), {
					text: "${ticketId}",
					width: 120,
					height: 120
					});
				<\/script>
				</body>
				</html>
			`);

			pwa.document.close();
		},
		openFile(fileName) {
			window.open(resourceDownload + fileName, "_blank");
		},
		sendMailTicket() {

			// 1️⃣ Validar correo antes de nada
			if (!this.selectedEmail || !this.validateEmail(this.selectedEmail)) {
				this.$fun.alert("Por favor ingrese un correo válido.", "warning");
				return; // detener la ejecución si no es válido
			}

			const finalBody = `
				<div style="font-family: Arial, sans-serif;">
				${this.textContent}
				<br><br>
				${this.ticketHTML}
				</div>
			`;

			const correo = {
				EmailPrs: this.selectedEmail,
				EmailBody: finalBody,
				Affair: `Equipo de Desarrollo TI: Recibimos su requerimiento - ticket ${this.selected.TskID}`
			}


			this.$fun.alertFull("Esta de seguro de enviar los correos?", "question")
				.then(res => {
					if (res.value) {
						this.dialogLoading = true;
						_sTaskService.SendMailTicket(correo, this.$fun.getUserID())
							.then(r => {
								this.dialogLoading = false;
								this.dialogPreviewMail = false;
								this.$fun.alert("Enviado Correctamente", "success");
							})
							.catch(error => {
								console.error("Error al enviar:", error);
								this.dialogLoading = false;
								this.$fun.alert("Error al enviar el correo", "error");
							});
					}
				});
		},

		// 2️⃣ Genera el HTML del ticket con QR
		generateTicketHTML(item) {
			if (!item) return '';

			return `
				<table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; width: auto;">
				<tr>
					<!-- Columna QR -->
					<td style="padding-right: 8px; vertical-align: top;">
					<img 
						src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${item.TskID}" 
						width="120" 
						height="120" 
						style="display: block;"
						alt="QR Ticket"
					/>
					</td>

					<!-- Columna Ticket info -->
					<td style="vertical-align: top;">
					<h2 style="margin: 0; font-size: 18px; line-height: 1.2;">TICKET</h2>
					<p style="margin: 4px 0 0 0; font-size: 14px; line-height: 1.2;">
						<strong>ID:</strong> ${item.TskID}
					</p>
					</td>
				</tr>
				</table>
			`;
		},
		// 3️⃣ Abre el dialog de preview del ticket
		previewTicket() {
			if (!this.selected) {
				this.$fun.alert("Seleccione una tarea", "warning");
				return;
			}

			if (!this.selected.PrsDocumentNumberAttended) {
				this.$fun.alert("La tarea seleccionada no tiene registrado el usuario que solicito el requerimiento", "warning");
				return;
			}
			this.textContent = `Estimado(a),<br><br>
			Hemos recibido su requerimiento: <strong>"${this.selected.TskTitle}"</strong>.<br><br>
			Para cualquier consulta o seguimiento, por favor comuníquese con nuestro equipo de soporte al correo: 
			<a href="mailto:desarrollador.ti@gmail.com">desarrollador.ti@gmail.com</a>.<br><br>
			Atte,<br>
			Equipo de Desarrollo`;

			this.selectedEmail = this.selected.PemEmailPrsAttended;
			this.ticketHTML = this.generateTicketHTML(this.selected);
			this.filterEmail.Affair = `Ticket ${this.selected.TskID}`;
			this.dialogPreviewMail = true;
		},
		
		enableEditing() {
			this.isEditing = true;

			this.$nextTick(() => {
				if (!this.quill) {
					this.quill = new Quill('#editor', {
						theme: 'snow'
					});

					this.quill.clipboard.dangerouslyPasteHTML(
						this.textContent || ''
					);
				}
			});
		},
		enableEmailEditing() {
			this.isEditingEmail = true;
			this.$nextTick(() => {
				const input = this.$el.querySelector('input');
				if (input) input.focus();
			});
		},
		
		
	},

	created() {
		const userInfo = this.$fun.getUserInfo();
		this.filter.AreID = (userInfo && userInfo.CtrContract) ? (userInfo.CtrContract.AreID ?? 0) : 0;
		this.filter.PrsID = (userInfo) ? (userInfo.PrsID ?? null) : null;
		console.log({ userInfo, filter: this.filter })

		for (let i = 1; i <= 53; i++) {
			this.itemsWeek.push({
				text: i,
				value: i,
			});
		}
		this.years = this.$fun.getTop5LastYears();
		this.year = this.$moment().year();
		this.initialize();
	},
	mounted() {

		this.filter.PrsID = this.$fun.getUserInfo().PrsID;

		// console.log( "USER INFO",this.$fun.getUserInfo()); 
	}
}
</script>

<style scoped>
.result-title {
	background-color: #3f51b5;
	color: white;
	padding: 16px 24px;
	font-weight: bold;
	border-bottom: 2px solid #fff;
	border-radius: 4px 4px 0 0;
	margin-bottom: 15px;
}

.rounded-xl {
	border-radius: 16px !important;
}

.hoverable:hover {
	background-color: rgba(0, 0, 0, 0.03);
	cursor: pointer;
}

.white--bg {
	background-color: white;
}

.elevation-1 {
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.upload-area {
	border: 2px dashed #E0E0E0;
	border-radius: 16px;
	cursor: pointer;
	transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	background-color: #fafafa;
	position: relative;
	overflow: hidden;
}

.upload-area.hovering {
	border-color: #3f51b5;
	background-color: #f0f2ff;
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.upload-area.file-ready {
	border-style: solid;
	border-color: #4CAF50;
	background-color: #f1f8e9;
}

.text-truncate {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 70%;
}

.scrollable {
	max-height: 450px;
	overflow-y: auto;
}

.bg-green {
	background-color: green;
}

.bordered-div {
	border: 1px solid grey;
	/* Borde negro de 2px */
	padding: 10px;
	/* Espaciado dentro del div */
	margin: 5px;
	border-radius: 5px;
	/* Esquinas redondeadas opcionales */
}

/* Contenedor general del correo */
.email-container {
	max-width: 800px;
	margin: 0 auto;
	padding: 16px;
	font-family: Arial, sans-serif;
	color: #202124;
}

/* Header tipo Gmail */
.email-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 16px;
	border-bottom: 1px solid #e0e0e0;
}

.email-title {
	font-size: 20px;
	font-weight: 400;
}

.email-label {
	background-color: #f1f3f4;
	color: #5f6368;
	padding: 0px 4px;
	border-radius: 4px;
	font-size: 11px;
	display: inline-flex;
	align-items: center;
}

.close-icon {
	margin-left: 4px;
	cursor: pointer;
	font-size: 16px;
	color: #5f6368;
	transform: translateY(-1px);
}

.email-actions {
	display: flex;
	justify-content: flex-end;
	gap: 12px;
}

/* Info del remitente */
.sender-info {
	display: flex;
	align-items: center;
	padding: 16px 0;
}

.profile-image {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	overflow: hidden;
	margin-right: 12px;
	border: 0.5px solid #c0c1c5;
}

.sender-details {
	flex-grow: 1;
}

.sender-email {
	font-weight: bold;
	font-size: 12px;
}

.recipient {
	font-size: 12px;
	color: #5f6368;
	display: flex;
	align-items: center;
}

.email-timestamp {
	font-size: 11px;
	color: #5f6368;
	display: flex;
	align-items: center;
	gap: 5px;
}

.email-options {
	display: flex;
	align-items: center;
	gap: 10px;
}

/* Contenido del correo */
.email-content {
	padding: 10px 0;
	font-size: 12px;
}

/* Línea divisoria */
.email-divider {
	height: 1px;
	background-color: #e0e0e0;
	margin: 16px 0;
}

/* Sección de adjunto/ticket */
.attachment-section-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
}

.attachment-section {
	display: flex;
	align-items: center;
	gap: 8px;
}

.attachment-label {
	font-weight: bold;
}

.attachment-info {
	font-size: 12px;
	color: #5f6368;
	display: flex;
	align-items: center;
	gap: 5px;
}

/* Contenedor del ticket */
.attachment-container {
	border: 1px solid #e0e0e0;
	border-radius: 4px;
	max-width: 100%;
	/* ancho máximo según contenedor del diálogo */
	padding: 16px;
	background-color: #fff;
	margin: 0 auto;
	position: relative;
}

/* Vista previa del ticket */
.attachment-preview {
	width: 100%;
	height: auto;
	/* ajusta según contenido */
	overflow: visible;
	text-align: center;
}

.attachment-preview img {
	max-width: 100%;
	/* se adapta al ancho del contenedor */
	height: auto;
	/* mantiene proporción */
	display: block;
	margin: 0 auto;
	/* centrado horizontal */
	object-fit: contain;
	/* evita recortes */
}

/* Detalles del ticket debajo de la imagen */
.attachment-details {
	display: flex;
	align-items: center;
	gap: 8px;
	justify-content: center;
	font-size: 12px;
	margin-top: 12px;
}

/* Estilo para iconos de descarga (si lo quieres activar) */
.download-icon {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.3s ease, visibility 0.3s;
	cursor: pointer;
}

.attachment-container:hover .download-icon {
	opacity: 1;
	visibility: visible;
}

#editor .ql-editor {
	padding: 0 !important;
}

.ql-editor p {
	margin: 0;
}

.email-label {
	font-weight: 500;
	color: #555;
	font-size: 0.9rem;
}

.email-value {
	font-weight: 600;
	color: #333;
	cursor: pointer;
}

.email-value:hover {
	text-decoration: underline;
}
</style>